<template>
  <v-dialog v-model="dialog" max-width="500">
    <template v-slot:activator="{ on }">
      <ButtonTooltip
        v-on="on"
        color="warning"
        icon="play_arrow"
        type="view"
        :tooltip="$t('adminVideo.buttons.viewFile')"
        @click.native="openDialog"
        :disabled="disabled"
      />
    </template>
    <v-card>
      <v-card-title class="">
        <v-icon @click="dialog = false">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <div v-if="type === 'VIDEO' && dialog" class="center-block">
        <video autoplay width="500" height="300" controls>
          <source :src="link" type="video/mp4" />
          <source :src="link" type="video/mov" />
          <source :src="link" type="video/ogg" />
          {{ $t('common.invalidVideoHtmlTag') }}
        </video>
      </div>
      <div v-if="type === 'AUDIO' && dialog" class="center-block py-5">
        <audio autoplay width="500" height="300" controls>
          <source :src="link" type="audio/mpeg" />
          <source :src="link" type="audio/ogg" />
          {{ $t('common.invalidAudioHtmlTag') }}
        </audio>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import ButtonTooltip from '@/components/adminVideo/ButtonTooltip'

import { viewFile } from '@/script/utils'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'ButtonTooltipView',

  components: {
    ButtonTooltip
  },

  data() {
    return {
      dialog: false
    }
  },

  props: ['indexName', 'disabled', 'url'],

  methods: {
    openDialog(type) {
      if (this.disabled) return
      this.dialog = true
    }
  },

  computed: {
    ...mapGetters('adminVideo', ['mediaFileUrl']),
    type() {
      if (this.indexName === 'audio') return 'AUDIO'
      else return 'VIDEO'
    },
    link() {
      return this.mediaFileUrl(this.indexName)
    }
  }
}
</script>

<style lang="sass" scoped>
.center-block
  display: flex
  justify-content: center
  align-items: center
  video
    height: 100%
    width: 100%
</style>
